import api from './api';
import { mapLeadDto, toLeadPayload } from '../dto/LeadDTO';

// Lead list — companies somebody wants to call, before they are pipeline deals.

export const getLeads = ({ scope = 'all', status = null, includeClosed = false } = {}) =>
    api.get('/Lead', { params: { scope, include_closed: includeClosed, ...(status ? { status } : {}) } })
        .then(res => res.data.map(mapLeadDto));

export const addLead = (lead) =>
    api.post('/Lead', toLeadPayload(lead)).then(res => res.data);

export const patchLead = (leadId, patch) =>
    api.patch(`/Lead/${leadId}`, patch).then(res => res.data);

/** Log one call attempt and decide the next step in the same request. */
export const logLeadCall = (leadId, { note, nextFollowUpDate, clearFollowUp, status }) =>
    api.post(`/Lead/${leadId}/calls`, {
        note: note || null,
        next_follow_up_date: nextFollowUpDate || null,
        clear_follow_up: Boolean(clearFollowUp),
        ...(status ? { status } : {}),
    }).then(res => res.data);

/** Promote a lead into a pipeline deal; returns { acquisition_id }. */
export const convertLead = (leadId, payload = {}) =>
    api.post(`/Lead/${leadId}/convert`, {
        project_title: payload.projectTitle || null,
        project_description: payload.projectDescription || null,
        deal_type: payload.dealType || 'project',
        expected_budget: payload.expectedBudget ?? null,
        estimated_close_date: payload.estimatedCloseDate || null,
        next_follow_up_date: payload.nextFollowUpDate || null,
    }).then(res => res.data);

export const deleteLead = (leadId) =>
    api.delete(`/Lead/${leadId}`).then(res => res.data);
